import React, {useState, useEffect} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import {
    getRatingColor,
    getTypesActivites, PARTICIPATION_STATUS,
    registerUserToSeanceAPI,
    unregisterUserToSeanceAPI
} from "../../services/SeanceService";
import {useModal} from "../../contexts/ModalContext";
import {useNavigate, useLocation} from "react-router-dom";
import {useUser} from "../../contexts/UserContext";
import {fetchWithFiltersLocal, fetchWithSortLocal, fetchWithFiltersAndSort} from "../../services/FilterService";
import FilterHamburger from "../../components/Filter/FilterHamburger";
import {saveRatingToAPI, saveRatingToLocal} from "../../services/RatingService";
import {
    faDownLong,
    faUpLong
} from "@fortawesome/free-solid-svg-icons";
import CardGridSmart from "../../components/Card/CardGridSmart";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";

const uriFilterName = 'filter';

function SeancesPage() {
    const {user} = useUser();
    const location = useLocation();
    const navigate = useNavigate();
    const {showModal, hideModal} = useModal();
    const params = new URLSearchParams(location.search);
    const [seances, setSeances] = useState([]);
    const [types, setTypes] = useState([]);
    const [allTypes, setAllTypes] = useState([]);
    const [title, setTitle] = useState("En cours de chargement...");
    const [cardsData, setCardsData] = useState([]); // Utiliser un état pour cardsData

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const handleRatingChange = async (newRating, seanceId) => {
        const saveRating = process.env.REACT_APP_MODE === 'maquette' ? saveRatingToLocal : saveRatingToAPI;

        try {
            const savedData = await saveRating(+newRating, +seanceId);

            if (savedData.success === true || savedData.success === 'true') {
                setSeances(seances.map(seance => seance.id === seanceId ? {...seance, rating: newRating} : seance));
                handleSuccess(savedData.msg);
            } else {
                handleError(savedData.msg);
            }
            return savedData;
        } catch (err) {
            handleError(err.msg);
        }
    };

    const handleLastRating = (rate, handleRatingChange) => {
        showModal('rating', {rate: rate, seance: user.lastSeance, onSaveRating: handleRatingChange});
    };

    useEffect(() => {
        if (!user) return;

        (async () => {
            let endpoint = '';
            let title = 'Page inconnue';
            const baseRoute = location.pathname.split('/')[1];
            const subRoute = location.pathname.split('/')[2];
            const dynamicValue = location.pathname.split('/')[3];

            switch (baseRoute) {
                case 'seances':
                    switch (subRoute) {
                        case 'all':
                            endpoint = '/all';
                            title = "Toutes les séances";
                            break;
                        case 'enregistrees':
                            endpoint = '/enregistrees';
                            title = "MES SÉANCES ENREGISTRÉES";
                            if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
                                endpoint = '/enregistrees';
                            } else if (user.roles.includes("ROLE_COACH")) {
                                endpoint = '/coach/disponibles';
                                title = "MES SÉANCES à VENIR";
                            }
                            break;
                        case 'disponibles':
                            endpoint = '/disponibles';
                            title = "SÉANCES DISPONIBLES";
                            if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
                                endpoint = '/disponibles';
                            }  else if (user.roles.includes("ROLE_COACH")) {
                                endpoint = '/coach/disponibles';
                                title = "MES SÉANCES à VENIR";
                            }
                            break;
                        case 'effectuees':
                            endpoint = '';
                            if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
                                endpoint = '/effectuees';
                            } else if (user.roles.includes("ROLE_COACH")) {
                                endpoint = '/coach/effectuees';
                            }
                            title = "MES SÉANCES EFFECTUÉES";

                            break;
                        case 'date':
                            if (dynamicValue) {
                                endpoint = `/date/${dynamicValue}`;
                                title = `LES SÉANCES DU ${DateService.formatDateJoli(dynamicValue).toUpperCase()}`;
                            }
                            break;
                        case 'referent':
                            switch (dynamicValue) {
                                case 'disponibles':
                                    endpoint = '/referent/disponibles';
                                    title = "Séances à venir";
                                    break;
                                case 'effectuees':
                                    endpoint = '/referent/effectuees';
                                    title = "Séances effectuées";
                                    break;
                                default:
                                    navigate('/seances/referent/disponibles');
                                    break;
                            }
                            break;
                        case 'coach':
                            switch (dynamicValue) {
                                case 'disponibles':
                                    endpoint = '/coach/disponibles';
                                    title = "Mes cours à venir";
                                    break;
                                case 'effectuees':
                                    endpoint = '/coach/effectuees';
                                    title = "Mes cours effectués";
                                    break;
                                default:
                                    navigate('/seances/coach/disponibles?sort=date');
                                    break;
                            }
                            break;
                        default:
                            title = "Page non trouvée";
                            break;
                    }
                    break;
                default:
                    title = "Page non trouvée";
                    break;
            }

            setTitle(title);

            if (endpoint) {
                const response = await getTypesActivites();
                setAllTypes(response.types);
                const params = new URLSearchParams(location.search);
                applyFiltersAndSort(params, baseRoute+endpoint);
            }
        })().catch(error => {
            console.error("Erreur lors de la récupération des données :", error);
            handleError();
        });

        if ((user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) && (user.lastSeance && user.lastSeance.rating === false && user.lastSeance.disableShowRatingModal === false)) {
            handleLastRating(null, handleRatingChange);
        }
    }, [location.search, user, location]);

    useEffect(() => {
        let myTypes = [];
        for (const type of allTypes) {
            for (const seance of seances) {
                if (seance["type"] === type["value"]) {
                    myTypes.push(type);
                    break;
                }
            }
        }
        setTypes(myTypes);
    }, [seances]);

    const applyFiltersAndSort = async (params, endpoint = location.pathname) => {
        const filterString = params.get(uriFilterName);
        const filters = filterString ? filterString.split(',') : [];

        const sort = params.get('sort');

        try {
            const response = await fetchWithFiltersAndSort({filters, sort}, endpoint);
            setSeances(response.seances.length > 0 ? response.seances : []);
        } catch (error) {
            console.error("Erreur lors de la récupération des données filtrées :", error);
            showModal('error', {
                children: "Une erreur est survenue lors de la récupération des séances",
                timeout: 1500
            });
        }
    }

    const handleFilterSubmit = (filters) => {
        const filterValues = Object.entries(filters)
            .filter(([key, val]) => val)
            .map(([key]) => key)
            .join(',');

        updateURLParams(uriFilterName, filterValues);
    };

    const handleSortSubmit = (sort) => {
        updateURLParams('sort', sort.sortOptions);
    };

    const updateURLParams = (type, value) => {
        switch (type) {
            case 'filter':
                if (value) {
                    params.set(uriFilterName, value);
                } else {
                    params.delete(uriFilterName);
                }
                break;
            case 'sort':
                params.set('sort', value);
                break;
            default:
                break;
        }

        navigate(`${location.pathname}?${params.toString()}`);
    };

    const handleRegister = async (id) => {

        const fetchThat = async () => {
            const response = await registerUserToSeanceAPI(id)
            if (!response.success) {
                console.error(response);
                handleError(response.msg);
            } else {
                handleSuccess(response.msg);
                setSeances(seances.map(seance => seance.id === id ? {
                    ...seance,
                    userRegistered: true,
                    asu_status: response.asu_status
                } : seance));
            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir vous inscrire à la séance ?",
            onConfirm: fetchThat,
        });

    };

    const handleUnregister = async (id) => {

        const fetchThat = async () => {
            const response = await unregisterUserToSeanceAPI(id)
            if (!response.success) {
                console.error(response);
                handleError(response.msg);
            } else {
                handleSuccess(response.msg);
                setSeances(seances.map(seance => seance.id === id ? {
                    ...seance,
                    userRegistered: false,
                    asu_status: response.asu_status
                } : seance));

            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir vous désinscrire de la séance ?",
            onConfirm: fetchThat,
        });
    };

    const onToggle = async (id) => {
        const seance = seances.find(seance => seance.id === id);
        if (!seance) return;

        const confirmMessage = seance.userRegistered ?
            "Êtes-vous sûr de vouloir vous désinscrire de la séance ?" :
            "Êtes-vous sûr de vouloir vous inscrire à la séance ?";

        showModal('confirm', {
            message: confirmMessage,
            onConfirm: async () => {
                const response = seance.userRegistered ?
                    await unregisterUserToSeanceAPI(id) :
                    await registerUserToSeanceAPI(id);

                if (response.success) {
                    handleSuccess(response.msg);
                    setSeances(seances.map(seance => seance.id === id ? {
                        ...seance,
                        userRegistered: !seance.userRegistered
                    } : seance));
                } else {
                    handleError(response.msg);
                }
            },
        });
    };

    const formatDateSeance = (date) => {
        let myDate = DateService.formatDateFull(date);
        return myDate.charAt(0).toUpperCase() + myDate.slice(1);
    }

    const getRowPlace = (seance) => {
        if (seance.status === 2 && seance.userRegistered) {
            return "Participants : " + seance.placesReservees;
        } else {
            return "Places disponibles : " + seance.placesRestantes
        }
    }

    useEffect(() => {
        if (!seances) return;

        let newCardsData = [];

        newCardsData = seances.map(seance => ({
            id: seance.id,
            lien: Routing.generate({route: Routing.routes.seance, params: { id: seance.id }}),
            image: seance.image,
            titre: seance.titre,
            userRegistered: seance.userRegistered,
            userRegisteredLabel: seance.userRegisteredLabel ?? "",
            userNonRegisteredLabel: seance.userNonRegisteredLabel ?? "",
            userPresence: seance.userPresence,
            date: seance.date,
            rows: [
                formatDateSeance(seance.date),
                getRowPlace(seance),
            ],
            waiting: [PARTICIPATION_STATUS.file_attente_non_prio.value, PARTICIPATION_STATUS.file_attente.value].includes(seance.asu_status),
            asu_status: seance.asu_status,
            status: seance.status,
            ratingColor: "transparent",
            ratingFilledColor: getRatingColor(seance),
            ratingHoverColor: "#f1c40f",
            ratingValue: seance.rate ? seance.rate.value : 0,
            onChange: (newRating) => handleRatingChange(newRating, seance.id),
            // onToggleSwitchActive: handleUnregister,
            // onToggleSwitchNotActive: handleRegister,
            onToggle: onToggle
        }));

        setCardsData(newCardsData);

    }, [seances, location.pathname]);


    const pasDeSeance = () => {
        if (seances.length < 1) {
            return "Aucune séance trouvée";
        }
        return null;
    }

    return (
        <div className="content">
            <TitleMain text={title}/>

            <FilterHamburger
                labelFilter={"Type de séance"}
                labelSort={"Trier par"}
                data={types}
                dataSort={[
                    /*
                    { value: 'nom', label: 'Nom croissant', next: "nomDesc", icon: faUpLong },
                    { value: 'nomDesc', label: 'Nom décroissant', next: "nom", icon: faDownLong },
                     */
                    {value: 'date', label: 'Date croissante', next: "dateDesc", icon: faUpLong},
                    {value: 'dateDesc', label: 'Date décroissante', next: "date", icon: faDownLong}
                ]}
                onFilterSubmit={handleFilterSubmit}
                onSortSubmit={handleSortSubmit}
                sortOptionFromUrl={params.get('sort')}
                filterOptionFromUrl={params.get(uriFilterName)}
            />

            {pasDeSeance()}

            {cardsData.length > 0 && <CardGridSmart cards={cardsData}/>}

        </div>
    )
}

export default SeancesPage;
